import UserEventsBoard from './UserEventsBoard/UserEventsBoard';

const UserEvents = () => {
  return <UserEventsBoard />;
};

export default UserEvents;
